import i18n from '@/i18n';

export default [
  {
    path: '/site-messages',
    name: 'site-messages',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'banner',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('site_messages')
    },
    // route level code-splitting
    component: () =>
      import('../../views/siteMessages/Index'),
    children: [
      {
        path: 'new',
        name: 'site-messages-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'banner',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('site_messages'),
        },
        component: () => import('../../views/siteMessages/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'site-messages-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'banner',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('site_messages'),
        },
        component: () => import('../../views/siteMessages/Edit.vue'),
      },
    ],
  },
];
